<template>
  <nav v-if="pages > 1" aria-label="Page navigation">
    <ul :class="ulClass">
      <li
        v-if="page !== 1"
        @click="SET_PAGINATION(page - 1)"
        :class="`${liClass} ${liClass}__arrows`"
      >
        <a :class="aClass" class="" href="javascript:void(0)">{{ prevText }}</a>
      </li>
      <template v-if="pages > 5">
        <li
          v-if="page !== 1"
          @click="SET_PAGINATION(1)"
          href="javascript:void(0)"
          :class="`${liClass} ${page === 1 ? activeClass : ''}`"
        >
          <a :class="aClass">{{ 1 }}</a>
        </li>
        <li
          v-if="page !== 1 && page !== 2"
          :class="liClass"
          href="javascript:void(0)"
        >
          <a :class="aClass" class="">...</a>
        </li>
        <li
          v-if="page !== 1 && page !== 2"
          :class="liClass"
          @click="SET_PAGINATION(page - 1)"
          href="javascript:void(0)"
        >
          <a :class="aClass">{{ page - 1 }}</a>
        </li>
        <li
          :class="`${liClass} ${activeClass}`"
          @click="SET_PAGINATION(page)"
          href="javascript:void(0)"
        >
          <a :class="aClass">{{ page }}</a>
        </li>
        <li
          v-if="page + 1 < pages"
          :class="liClass"
          @click="SET_PAGINATION(page + 1)"
          href="javascript:void(0)"
        >
          <a :class="aClass">{{ page + 1 }}</a>
        </li>
        <li
          v-if="page !== pages && page !== pages - 1"
          :class="liClass"
          href="javascript:void(0)"
        >
          <a :class="aClass" class="">...</a>
        </li>
        <li
          v-if="page !== pages"
          :class="liClass"
          @click="SET_PAGINATION(pages)"
          href="javascript:void(0)"
        >
          <a :class="aClass">{{ pages }}</a>
        </li>
      </template>
      <template v-else>
        <li
          @click="SET_PAGINATION(pageCount)"
          v-for="(pageCount, i) in pages"
          href="javascript:void(0)"
          :key="i"
          :class="`${liClass} ${page === pageCount ? activeClass : ''}`"
        >
          <a :class="aClass">{{ pageCount }}</a>
        </li>
      </template>
      <li
        v-if="page !== pages"
        @click="SET_PAGINATION(page + 1)"
        :class="`${liClass} ${liClass}__arrows`"
      >
        <a :class="aClass" class="" href="javascript:void(0)">{{ nextText }}</a>
      </li>
      <li :class="`${liClass} ${liClass}__input`">
        <BaseInput
          :value="page"
          @input="SET_PAGINATION"
          type="number"
          block
        ></BaseInput>
      </li>
    </ul>
  </nav>
</template>

<script>
import BaseInput from "./Inputs/BaseInput.vue";
export default {
  components: { BaseInput },
  props: {
    page: {
      default: 1,
    },
    pages: {
      default: 1,
    },
    ulClass: {
      default: "pagination",
    },
    liClass: {
      default: "page-item",
    },
    aClass: {
      default: "page-link",
    },
    activeClass: {
      default: "page-link",
    },
    nextText: {
      default: ">",
    },
    prevText: {
      default: "<",
    },
  },
  methods: {
    SET_PAGINATION(page) {
      this.$emit("change", page);
    },
  },
};
</script>

<style></style>
